module.exports = __webpack_public_path__ + "static/media/post-test@2x.4b5f7334.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/post-test@2x.png
// module id = 526
// module chunks = 0